import React, {PureComponent} from "react"

import Loading from "@irati/ui/src/Loading"
import {connect} from "@irati/store"
import {Auth} from "@irati/auth/types"

import authentication from "@irati/auth"
import LangActions from "./store/actions"

type getContent = (buckets: string[], locale: string, forceUpdate: boolean) => Promise<any>

interface Props {
  bucket: string
  buckets: string[]
  getContent: getContent
  forceUpdate: boolean
  auth: Auth
}

interface State {
  load: Promise<any>
}

class LangLoader extends PureComponent<Props, State> {
  static defaultProps = {
    bucket: null,
    buckets: [],
    forceUpdate: false
  }

  constructor(props: Props) {
    super(props)
    this.state = {
      load: this.loadContent()
    }
  }

  loadContent = () => {
    const {getContent, forceUpdate} = this.props
    const buckets = this.getBucketsToLoad()
    return getContent(buckets, this.getLocale(), forceUpdate)
  }

  getBucketsToLoad = () => {
    const {bucket, buckets} = this.props
    if (bucket) return [bucket]
    return buckets
  }

  getLocale = () => {
    return authentication.userLocale()
  }

  render() {
    const {load} = this.state

    return <Loading {...this.props} load={load} />
  }
}

const mapStateToProps = ({auth}: {auth: Auth}) => ({auth})

export const actions = (dispatch: any): {getContent: getContent} => {
  return {
    getContent: (buckets, locale, forceUpdate) => dispatch(LangActions.get(buckets, locale, forceUpdate))
  }
}

export default connect(mapStateToProps, actions)(LangLoader)
